
import { Outlet } from 'react-router-dom';
import './assets/css/style.css';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';

const App = () => {
  return <>
        <Header />
        <Outlet />
        <Footer />
  </>
}


export default App;
